import * as React from "react";
import { InputPower, OutputPower } from "./Power"
import { ValueText } from "./ValueText"
import { ComparisonItem, Value } from "../../master/interface"

type ComparisonListItemProps =
  {
    item: ComparisonItem,
    value: Value<any> | null,
  }

export const ComparisonListItem: React.FC<ComparisonListItemProps> = ({item, value}) => {
  const pureValue = getPureValue(value)
  const inputPower = typeof value === 'object' && value !== null && 'input' in value && value.input

  return (
    <div className="h-20 p-1 bg-white grid grid-cols-3 items-center lg:grid-cols-1 lg:h-36 lg:p-3">
      <div className="text-xs text-center text-gray-400 lg:pb-2">
        <div className="flex items-end">
          <img className="max-h-6 m-auto mb-2" style={{maxWidth: "2rem"}} src={item.image} alt={item.name}/>
        </div>
        <div className="text-xs lg:text-sm">
          {item.name}
        </div>
        {inputPower && <InputPower power={inputPower} />}
        {'power' in item && <OutputPower power={item.power} />}
      </div>
      <div className="col-span-2 text-3xl text-center border-l border-gray-300 lg:border-l-0 lg:border-t lg:pt-2">
        {pureValue ? <ValueText prefix={item.prefix} unit={item.unit}>{ pureValue }</ValueText> : "-"}
      </div>
    </div>
  )
}

const getPureValue = (value: Value<any> | null): string => {
  if (value === null) {
    return null
  }

  if (Array.isArray(value)) {
    return value.join('、')
  }

  if (typeof value === "object" && "value" in value) {
    return String(value.value)
  }

  return String(value)
}